import React, { useCallback, useContext, useEffect, useState } from 'react';

import { dispatch } from '../../../../../../Shared/js/redux/store';
import { selectOptions } from '../../../../../js/@types/SearchFilters';
import { actions } from '../../../../../js/redux/modalSlice';
import { SearchFilterContext, SearchFilterContextData } from '../SearchFilterContext';

let include: string;
let exclude: string;
const phone = 'phone';
const tv = 'tv';
const lineRental = 'lineRental';
const mobile = 'mobile';

function BuildOptionString(prefix: string, state: boolean): string {
    return state ? prefix + include : prefix + exclude;
}

function BuildInitalState(context: SearchFilterContextData): Array<string> {
    const stateArray: string[] = [];
    if (context.criteria.bundles.homePhone !== null)
        stateArray.push(BuildOptionString(phone, context.criteria.bundles.homePhone));

    if (context.criteria.bundles.mobilePhone !== null)
        stateArray.push(BuildOptionString(mobile, context.criteria.bundles.mobilePhone));

    if (context.criteria.bundles.tv !== null) stateArray.push(BuildOptionString(tv, context.criteria.bundles.tv));

    if (context.criteria.bundles.lineRental !== null)
        stateArray.push(BuildOptionString(lineRental, context.criteria.bundles.lineRental));

    if (stateArray.length === 0) {
        return [''];
    }
    return stateArray;
}

export default function BundleSelect() {
    const context = useContext(SearchFilterContext);
    include = context.data.resources.include;
    exclude = context.data.resources.exclude;
    const [optionsSelected, setOptionsSelected] = useState(Array<string>(...BuildInitalState(context)));
    const [tvOptionsSelected, setTvOptionsSelected] = useState(
        Array<string>(...context.criteria.bundles.tvChannels.map<string>(tc => tc.toString()))
    );
    const [showTvChannels, setShowTvChannels] = useState(context.criteria.bundles.tv === true);

    useEffect(() => {
        const select = wo$('#choose-bundles');
        select.selectpicker('refresh');

        if (optionsSelected.some(os => os === '')) {
            dispatch(actions.updatePhoneBundle(null));
            dispatch(actions.updateTvBundle(null));
            dispatch(actions.updateLineRentalBundle(null));
            dispatch(actions.updateMobileBundle(null));
            return;
        }

        dispatch(
            actions.updatePhoneBundle(
                optionsSelected.some(os => os === phone + include)
                    ? true
                    : optionsSelected.some(os => os === phone + exclude)
                      ? false
                      : null
            )
        );

        if (optionsSelected.some(os => os === tv + include)) {
            dispatch(actions.updateTvBundle(true));
        } else {
            dispatch(actions.updateTvBundle(optionsSelected.some(os => os === tv + exclude) ? false : null));
            setTvOptionsSelected([]);
        }

        if (context.data.showLineRental) {
            dispatch(
                actions.updateLineRentalBundle(
                    optionsSelected.some(os => os === lineRental + include)
                        ? true
                        : optionsSelected.some(os => os === lineRental + exclude)
                          ? false
                          : null
                )
            );
        }
        if (context.data.showMobilePhoneBundle) {
            dispatch(
                actions.updateMobileBundle(
                    optionsSelected.some(os => os === mobile + include)
                        ? true
                        : optionsSelected.some(os => os === mobile + exclude)
                          ? false
                          : null
                )
            );
        }
    }, [optionsSelected, context.data]);

    useEffect(() => {
        const select = wo$('choose-tv-channels');
        select.selectpicker('refresh');

        const values = [...tvOptionsSelected.map(tv => Number.parseInt(tv))];
        dispatch(actions.updateTvChannels(values));
    }, [tvOptionsSelected]);

    const onChangeCallBack = useCallback(
        e => {
            const options = [...e.target.selectedOptions];
            let values = options.map(option => option.value);
            if (values.some(o => o === '')) {
                if (!optionsSelected.some(o => o === '')) {
                    setOptionsSelected(Array(...['']));
                    setShowTvChannels(false);
                    return;
                } else if (values.length >= 1) {
                    values = values.filter(o => o !== '');
                }
            }

            const tvIncluded = values.some(os => os === tv + include);
            setShowTvChannels(tvIncluded);
            setOptionsSelected([...values]);
        },
        [optionsSelected]
    );

    const onLoad = useCallback((node: HTMLElement) => {
        const element = jQuery(node);
        WhistleOut.applySelectPicker(element);
    }, []);

    const OnTvChangeCallBack = useCallback(e => {
        const options = [...e.target.selectedOptions];

        setTvOptionsSelected(options.map(o => o.value));
    }, []);

    function buildChannelOptions(options: selectOptions[]) {
        return options.map(o => {
            return (
                <option key={o.key} value={o.key}>
                    {o.value}
                </option>
            );
        });
    }

    return (
        <div>
            <h5 className="font-5">{context.data.resources.bundle}</h5>
            <div className="selectpicker-wide">
                <select
                    id="choose-bundles"
                    tabIndex={-1}
                    className="selectpicker bs-select-hidden"
                    multiple={true}
                    onChange={onChangeCallBack}
                    value={optionsSelected}
                    ref={onLoad}
                    data-selected-text-format="count>1"
                >
                    <option key="" value="">
                        {context.data.resources.showAllBundles}
                    </option>
                    <optgroup label={context.data.resources.phoneBundle} data-max-options="1">
                        <option
                            key="pI"
                            value={phone + include}
                            title={`${include} ${context.data.resources.phoneBundle}`}
                        >
                            {include}
                        </option>
                        <option
                            key="pE"
                            value={phone + exclude}
                            title={`${exclude} ${context.data.resources.phoneBundle}`}
                        >
                            {exclude}
                        </option>
                    </optgroup>
                    <optgroup label={context.data.resources.tvBundle} data-max-options="1">
                        <option key="tvI" value={tv + include} title={`${include} ${context.data.resources.tvBundle}`}>
                            {include}
                        </option>
                        <option key="tvE" value={tv + exclude} title={`${exclude} ${context.data.resources.tvBundle}`}>
                            {exclude}
                        </option>
                    </optgroup>
                    {context.data.showLineRental ? (
                        <optgroup label={context.data.resources.lineRental} data-max-options="1">
                            <option
                                key="lrI"
                                value={lineRental + include}
                                title={`${include} ${context.data.resources.lineRental}`}
                            >
                                {include}
                            </option>
                            <option
                                key="lrE"
                                value={lineRental + exclude}
                                title={`${exclude} ${context.data.resources.lineRental}`}
                            >
                                {exclude}
                            </option>
                        </optgroup>
                    ) : null}
                    {context.data.showMobilePhoneBundle ? (
                        <optgroup label={context.data.resources.mobilePhoneBundle} data-max-options="1">
                            <option
                                key="mI"
                                value={mobile + include}
                                title={`${include} ${context.data.resources.mobilePhoneBundle}`}
                            >
                                {include}
                            </option>
                            <option
                                key="mE"
                                value={mobile + exclude}
                                title={`${exclude} ${context.data.resources.mobilePhoneBundle}`}
                            >
                                {exclude}
                            </option>
                        </optgroup>
                    ) : null}
                </select>
                {context.data.showTvChannels ? (
                    <span hidden={!showTvChannels}>
                        <select
                            id="choose-tv-channels"
                            title={context.data.resources.mustHaveChannels}
                            className="selectpicker bs-select-hidden mar-t-3"
                            value={tvOptionsSelected}
                            onChange={OnTvChangeCallBack}
                            multiple={true}
                            ref={onLoad}
                            data-selected-text-format="count>1"
                        >
                            <optgroup label={context.data.resources.individualChannels}>
                                {buildChannelOptions(context.data.individualTvChannels)}
                            </optgroup>
                            <optgroup label={context.data.resources.kidsChannels}>
                                {buildChannelOptions(context.data.kidsTvChannels)}
                            </optgroup>
                            <optgroup label={context.data.resources.sportsChannels}>
                                {buildChannelOptions(context.data.sportsTvChannels)}
                            </optgroup>
                        </select>
                    </span>
                ) : null}
            </div>
        </div>
    );
}
